export default "__VITE_ASSET__59136856__"